import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import Person from '../form/person'
import {TableDocumentWrapper} from '../table/documents'
import {useCentral} from '../../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {TableClotheWrapper} from '../table/clothes'
const DocumentTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      currentExternalTab: 0,
      fromCreateButton: false,
    }
    // reset()
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs
        className={'sdx_sub_react_tab_panel '}
        selectedIndex={currentTabItem.currentExternalTab}
        onSelect={(index) => {
          const obj: TabCentralModel = {
            ...currentTabItem,
            currentExternalTab: index,
          }
          changeCurrentTabItem(obj)
        }}
      >
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('IDENTIFICACION/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Identificaciones</Tab>
          )}
          {isAllowed('PRENDA/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>Prendas</Tab>}
        </TabList>
        <TabPanel>
          <Person />
        </TabPanel>
        {isAllowed('IDENTIFICACION/ACCESO') && (
          <TabPanel>
            <TableDocumentWrapper />
          </TabPanel>
        )}
        {isAllowed('PRENDA/ACCESO') && (
          <TabPanel>
            <TableClotheWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default DocumentTab
